import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import {
  Breadcrumbs,
  Link,
  TablePagination,
  Typography,
} from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useQualidadeCadastroItemProcessosRiscosListaViewModel } from "../../viewModels/qualidade_cadastro_processos_riscos_itens_view_model";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import FormContainer from "../../../../../common/components/form_container";
import { ItemProcessoRiscosInteresseLista } from "../../../domain/models/processos_riscos_item_interesse_lista";
import { ItemProcessoFatorLista } from "../../../domain/models/processos_riscos_item_fator_lista";
import { GenerateQualidadeItemProcessosFatorColumns } from "./columns/qualidade_processos_fator_item";
import { ItemProcessoIndicadorLista } from "../../../domain/models/processos_riscos_item_indicador_lista";
import { GenerateQualidadeItemProcessosIndicadorColumns } from "./columns/qualidade_processos_indicador_item";
import { GenerateQualidadeItemProcessosInteresseColumns } from "./columns/qualidade_processos_interesse";
import { useMemo } from "react";
import { BackButton } from "../../../../../common/components/back_button";
import { IndicadorModal } from "./components/indicador_modal";
import { InteresseModal } from "./components/interesse_modal";
import { FatorModal } from "./components/fator_modal";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { isValidId } from "../../../../../common/utils/utils";

export const CadastroProcessosRiscosItens = () => {
  const viewModel = useQualidadeCadastroItemProcessosRiscosListaViewModel();

  const QualidadeItemProcessoInteresseListaColumns = useMemo(() => {
    return GenerateQualidadeItemProcessosInteresseColumns({
      onActionEditar: viewModel.handleCadastroItemProcessoInteresse,
      onActionDeletar:
        viewModel.handleDeleteItemProcessoInteresseModalOpenState,
    });
  }, [
    viewModel.handleCadastroItemProcessoInteresse,
    viewModel.handleDeleteItemProcessoInteresseModalOpenState,
  ]);

  const QualidadeItemProcessoFatorListaColumns = useMemo(() => {
    return GenerateQualidadeItemProcessosFatorColumns({
      onActionEditar: viewModel.handleCadastroItemProcessoFator,
      onActionDeletar: viewModel.handleDeleteItemProcessoFatorModalOpenState,
    });
  }, [
    viewModel.handleCadastroItemProcessoFator,
    viewModel.handleDeleteItemProcessoFatorModalOpenState,
  ]);

  const QualidadeItemProcessoIndicadorListaColumns = useMemo(() => {
    return GenerateQualidadeItemProcessosIndicadorColumns({
      onActionDeletar:
        viewModel.handleDeleteItemProcessoIndicadorModalOpenState,
    });
  }, [viewModel.handleDeleteItemProcessoIndicadorModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2 items-center">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={viewModel.handleReportProcessosRiscos}
                  buttonColor="yellow"
                >
                  Relatórios
                </PrimaryButton>
              </div>
              <BackButton onClick={() => viewModel.handleVoltar()} />
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-6 flex-col md:p-10 px-4 pt-8 mb-12">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Cadastro Processos e Riscos
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Cadastro de Processos e Riscos
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer title={"Ano"} arrangement="fullRow">
              <div className="flex flex-col w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                  <DefaultFormInput
                    name="Descricao"
                    label="Processo"
                    reactHookForm={viewModel.hookForm}
                    required={true}
                  />

                  <FormDatePickerInput
                    name="DataAtualizacao"
                    label="Data Atualização"
                    required={true}
                    reactHookForm={viewModel.hookForm}
                  />
                  <DropDownFuncionario
                    name="IdFuncionarioResponsavel"
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                    label="Responsável"
                  />

                  <DropDownFuncionario
                    name="IdFuncionarioCoresp"
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                    label="Co-Responsável"
                  />
                  <div className="md:col-span-2">
                    <DefaultFormInput
                      name="Observacao"
                      label="Observação"
                      multiline={true}
                      rows={4}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>
              </div>
            </FormContainer>
            <div className="mb-4">
              <span className="text-lg font-semibold">
                Objetivos Relacionados
              </span>
            </div>
            {/* FORMULARIO INDICADOR */}
            <div className="w-40 mt-4 mb-4">
              <PrimaryButton
                type="button"
                onClick={viewModel.handleNewIndicador}
                buttonColor={"primary-green"}
              >
                Novo
              </PrimaryButton>
            </div>
            {viewModel.IdItemProcesso ? (
              <>
                <StyledDataGrid
                  tableName="ProcessoIndicadoresLista"
                  disableColumnMenu={false}
                  getRowId={(row: ItemProcessoIndicadorLista) =>
                    row.IdItemProcessoIndicador
                  }
                  columns={QualidadeItemProcessoIndicadorListaColumns}
                  loading={viewModel.loading}
                  rows={viewModel.itemProcessosIndicadorLista}
                  rowCount={viewModel.paginationProcessosIndicado.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="medio"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationProcessosIndicado.page,
                    pageSize: viewModel.paginationProcessosIndicado.rowsPerPage,
                  }}

                />

                <TablePagination
                  component="div"
                  count={viewModel.paginationProcessosIndicado.totalItems}
                  page={viewModel.paginationProcessosIndicado.page - 1}
                  onPageChange={(_, p) =>
                    viewModel.handlePageIndicadorChange(p)
                  }
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={
                    viewModel.paginationProcessosIndicado.rowsPerPage
                  }
                  onRowsPerPageChange={(e) =>
                    viewModel.handleRowsPerPageIndicadorChange(
                      parseInt(e.target.value),
                    )
                  }
                />
              </>
            ) : (
              <></>
            )}
            <div className="mb-4">
              <span className="text-lg font-semibold">Partes Interessadas</span>
            </div>
            {/* FORMULARIO INTERESSE */}
            <>
              <div className="w-40 mt-4 mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleNewInteresse}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>
              {viewModel.IdItemProcesso ? (
                <>
                  <StyledDataGrid
                    tableName="ProcessoRiscosLista"
                    disableColumnMenu={false}
                    getRowId={(row: ItemProcessoRiscosInteresseLista) =>
                      row.IdItemProcessoInteresse
                    }
                    columns={QualidadeItemProcessoInteresseListaColumns}
                    loading={viewModel.loading}
                    rows={viewModel.itemProcessosInteresseLista}
                    rowCount={viewModel.paginationInteresse.totalItems}
                    sx={{
                      "& .status-header": {
                        backgroundColor: "#AFDFD5",
                        color: "#000",
                      },
                    }}
                    pageSizeOptions={[10]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.paginationInteresse.page,
                      pageSize: viewModel.paginationInteresse.rowsPerPage,
                    }}
                    autoHeight={true}
                    textSize="medio"
                    getRowHeight={() => "auto"}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.paginationInteresse.totalItems}
                    page={viewModel.paginationInteresse.page - 1}
                    onPageChange={(_, p) =>
                      viewModel.handlePageInteresseChange(p)
                    }
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.paginationInteresse.rowsPerPage}
                    onRowsPerPageChange={(e) =>
                      viewModel.handleRowsPerPageInteresseChange(
                        parseInt(e.target.value),
                      )
                    }
                  />
                </>
              ) : (
                <></>
              )}

              <div className="mb-4">
                <span className="text-lg font-semibold">
                  Cadastro de Fatores Internos/Externos, riscos e oportunidades
                </span>
              </div>

              {/* FORMULARIO FATOR */}
              <div className="w-40 mt-4 mb-4">
                <PrimaryButton
                  type="button"
                  onClick={viewModel.handleNewFator}
                  buttonColor={"primary-green"}
                >
                  Novo
                </PrimaryButton>
              </div>

              {viewModel.IdItemProcesso ? (
                <>
                  <StyledDataGrid
                    tableName="ProcessoFatorLista"
                    disableColumnMenu={false}
                    getRowId={(row: ItemProcessoFatorLista) =>
                      row.IdItemProcessoFator
                    }
                    columns={QualidadeItemProcessoFatorListaColumns}
                    loading={viewModel.loading}
                    rows={viewModel.itemProcessosFatorLista}
                    rowCount={viewModel.paginationFator.totalItems}
                    sx={{
                      "& .status-header": {
                        backgroundColor: "#AFDFD5",
                        color: "#000",
                      },
                    }}
                    pageSizeOptions={[10]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.paginationFator.page,
                      pageSize: viewModel.paginationFator.rowsPerPage,
                    }}
                    autoHeight={true}
                    textSize="medio"
                    getRowHeight={() => "auto"}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.paginationFator.totalItems}
                    page={viewModel.paginationFator.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageFatorChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.paginationFator.rowsPerPage}
                    onRowsPerPageChange={(e) =>
                      viewModel.handleRowsPerPageFatorChange(
                        parseInt(e.target.value),
                      )
                    }
                  />
                </>
              ) : (
                <></>
              )}
            </>
          </div>
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.IdItemProcesso) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>
            <div className="flex flex-row gap-4 ml-auto">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={() => viewModel.handleVoltar()}
                >
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    onClick={viewModel.hookForm.handleSubmit(
                      viewModel.handleItemProcessosRiscosSubmit,
                    )}
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
      <ReportViewerModal reportViewerState={viewModel.reportViewerState} />

      <IndicadorModal
        open={viewModel.openIndicador}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() => viewModel.setOpenIndicador(false)}
        onSubmit={viewModel.handleItemIndicadoresSubmit}
        ddlIndicadores={viewModel.ddlIndicadores}
      />
      <InteresseModal
        open={viewModel.openInteresse}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedItemProcessosInteresse={
          viewModel.selectedItemProcessosInteresse ?? null
        }
        onClose={() => viewModel.setOpenInteresse(false)}
        onSubmit={viewModel.handleItemProcessosRiscosInteresseSubmit}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />
      <FatorModal
        open={viewModel.openFator}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedItemProcessosFator={
          viewModel.selectedItemProcessosFator ?? null
        }
        onClose={() => viewModel.setOpenFator(false)}
        onSubmit={viewModel.handleItemProcessosFatorSubmit}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.processosInteresseDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteItemProcessoInteresseModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaItemProcessosInteresse}
      />
      <DeleteDialog
        open={viewModel.processosFatorDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteItemProcessoFatorModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaItemProcessosFator}
      />

      <DeleteDialog
        open={viewModel.processosIndicadorDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteItemProcessoIndicadorModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaItemProcessosIndicadore}
      />
    </>
  );
};
